import { render, staticRenderFns } from "./pendingAssignments.vue?vue&type=template&id=09a74403&scoped=true&"
import script from "./pendingAssignments.vue?vue&type=script&lang=js&"
export * from "./pendingAssignments.vue?vue&type=script&lang=js&"
import style0 from "./pendingAssignments.vue?vue&type=style&index=0&id=09a74403&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a74403",
  null
  
)

export default component.exports